module.exports = __webpack_public_path__ + "img/link2.64ffd0be.svg";